<template>
  <div>
    <multiselect
      class="form-control form-group-sm"
      style="width:100%"
      v-model="modelo.idusuario"
      :options="datos"
      track-by="id"
      label="nombres"
      :searchable="true"
      :close-on-select="true"
      :multiple="multiple"
      :loading="isLoading"
      :show-labels="false"
      :placeholder="xholder"
    >
    </multiselect>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import { parseJsonError } from '@/components/Utils.js';
  export default {
    props: {
      model: Object,
      models: { type: Object, required: false },
      multiple: { type: Boolean, required: false, default: false },
      current: { type: Boolean, required: false, default: false },
      xdefault: { type: Number, required: false },
      xonlyasesores: { type: Boolean, required: false, default: false },
      xholder: { type: String, required: false, default: 'Seleccione...' },
      xidsede: { type: Number, required: false, default: -1 },
    },
    data() {
      return {
        datos: [],
        isLoading: true,
        modelo: {
          idusuario: null,
        },
      };
    },
    watch: {
      'modelo.idusuario': function() {
        if (this.models != null) {
          this.models.usuarios = this.modelo.idusuario;
        } else {
          this.model.idusuario = this.modelo.idusuario;
        }
      },
      '$store.state.CARGO': function(a) {
        if (a == null) return;
        this.getDatos();
      },
      xidsede: function(a) {
        if (a == -1) return;
        this.getDatos();
      },
      xdefault: function() {
        if (this.xdefault) {
          let uni = this.datos.find((x) => x.id == this.xdefault);
          if (uni) this.modelo.idusuario = uni;
        }
      },
    },
    methods: {
      async getDatos() {
        var vue = this;
        vue.isLoading = true;
        vue.modelo.idusuario = null;
        if (vue.model) vue.model.idusuario = null;
        var idcargo = this.$store.state.CARGO.id;
        var iduser = this.$store.state.DATA_USER.id;
        var idsede = this.$store.state.CARGO.idsede;
        if (this.xidsede > 0) idsede = this.xidsede;
        var sql = gql`query{ getSede(id:${idsede}){usuarios_activos{usuario{estado,datos_personales{id,nombres,pri_apellido,seg_apellido},cargos{cargo{id,nombre}},}}} }`;
        await this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            var sed = data.data.getSede;
            // window.console.log( '>',sed,null,4 )
            var datas = [];
            if (sed.usuarios_activos == null) return;
            if (vue.xonlyasesores && idcargo != 1) {
              sed.usuarios_activos = sed.usuarios_activos.filter(function(e) {
                let isase = e.usuario.cargos.find((x) => x.cargo.id == 12 || x.cargo.id == 13);
                if (isase) return true;
                return false;
              });
            }
            sed.usuarios_activos.forEach(function(e) {
              var dp = e.usuario.datos_personales;
              var seg = dp.seg_apellido == null ? '' : dp.seg_apellido;
              var no = dp.nombres + ' ' + dp.pri_apellido + ' ' + seg;
              if (e.usuario.estado && e.usuario.datos_personales.id != 2) datas.push({ id: dp.id, nombres: no });
            });

            if (idcargo == 13) {
              datas = datas.filter(function(e) {
                return e.id == iduser;
              });
            }
            vue.datos = datas;
            if (this.current) {
              var de = datas.find((x) => x.id == this.$store.state.DATA_USER.id);
              this.modelo.idusuario = de;
            }

            if (this.xdefault) {
              let uni = this.datos.find((x) => x.id == this.xdefault);
              if (uni) this.modelo.idusuario = uni;
            }

            this.isLoading = false;
          })
          .catch((error) => {
            window.console.error(error);
            vue.isLoading = false;
            vue.$notify(parseJsonError(error, 'getSede'));
          });
      },
    },
    mounted() {
      if (this.$store.state.CARGO) this.getDatos();
    },
  };
</script>
